import React, { useState, useEffect } from 'react';
import ContactForm from '../layouts/ContactForm';

const slides = [
    { id: 1, text: "Slide 1", color: "red", src: "assets/Agile_Consulting.png" },
    { id: 2, text: "Slide 2", color: "blue", src: "assets/DevSecOps_Consulting.png" },
    { id: 3, text: "Slide 3", color: "green", src: "assets/UI_UX_Consulting.png" },
    { id: 4, text: "Slide 4", color: "black", src: "assets/AI_Consulting.png" },

];

const slider1 = [
    { id: 1, text: "Slide 1", color: "red", src: "assets/movoto-background.png" },
    { id: 2, text: "Slide 2", color: "blue", src: "assets/Sagent_background.png" },
    { id: 3, text: "Slide 3", color: "green", src: "assets/Switchfly_Background.png" },
    { id: 4, text: "Slide 4", color: "black", src: "assets/AI_Consulting.png" },

];

const slider2 = [
    { id: 1, text: " challenges, slower site performance, and a corresponding erosion of customer experience", color: "red" },
    { id: 2, text: "Data fragmentation and associated analytical challenges, slower site performance, and a corresponding erosion of customer experience", color: "blue" },
    { id: 3, text: "Data fragmentation and associated analytical challenges, slower site performance, and a corresponding erosion of customer experience", color: "green" },
    { id: 4, text: "Data fragmentation and associated analytical challenges, slower site performance, and a corresponding erosion of customer experience", color: "black" },

];

const About = () => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    /* sliders start*/
    const [currentIndex, setCurrentIndex] = useState(0);
    const visibleSlides = 3; // Number of slides to display at a time

    const nextSlide = () => {
        setCurrentIndex((prevIndex) =>
            prevIndex + 1 >= slides.length - (visibleSlides - 1) ? 0 : prevIndex + 1
        );
    };

    const prevSlide = () => {
        setCurrentIndex((prevIndex) =>
            prevIndex - 1 < 0 ? slides.length - visibleSlides : prevIndex - 1
        );
    };

    /* sliders end*/

    /* sliders-1 start*/
    const [currentIndex1, setCurrentIndex1] = useState(0);
    const visibleSlides1 = 3; // Number of slides to display at a time

    const nextSlide1 = () => {
        setCurrentIndex((prevIndex) =>
            prevIndex + 1 >= slides.length - (visibleSlides - 1) ? 0 : prevIndex + 1
        );
    };

    const prevSlide1 = () => {
        setCurrentIndex((prevIndex) =>
            prevIndex - 1 < 0 ? slides.length - visibleSlides : prevIndex - 1
        );
    };

    /* sliders-1 end*/


    /* slider-2 start */

    const [currentIndex2, setCurrentIndex2] = useState(0);
    const visibleSlides2 = 3; // Number of slides to display at a time

    const nextSlide2 = () => {
        setCurrentIndex((prevIndex) =>
            prevIndex + 1 >= slides.length - (visibleSlides - 1) ? 0 : prevIndex + 1
        );
    };

    const prevSlide2 = () => {
        setCurrentIndex((prevIndex) =>
            prevIndex - 1 < 0 ? slides.length - visibleSlides : prevIndex - 1
        );
    };

    /* sliders-2 end */

    return (
        <>
            <div className="container-fluid service-banner">
                <h1>When Our Candidates Thrive, We Grow</h1>
                <hr />
                <p>Since our inception in February 2024, Shanvatech has been redefining hiring solutions by offering comprehensive, end-to-end recruitment services. Unlike firms that focus solely on leadership hiring, we specialize in identifying and placing talent across all levels—ensuring businesses build strong, capable teams from the ground up.</p>
                <p>As a dynamic and evolving company, we stay attuned to industry shifts, equipping organizations with the right talent to drive success. Whether partnering with well-established enterprises or emerging startups, we tailor our approach to meet diverse hiring needs with precision and efficiency.</p>
                <p style={{paddingBottom: "20px"}}>Our meticulous selection process ensures that every candidate aligns with our core values of quality, integrity, and excellence. Their success fuels our reputation as a trusted recruitment partner, and our clients continually rely on us for their most critical hiring needs.</p>
                <button style={{ borderRadius: "10px", padding: "10px 30px 10px 30px", fontSize: "20px" }}>PARTNER WITH SHANVATECH <i className="fas fa-arrow-right"></i></button>
            </div>

            <div className="container-fluid"
                style={{ backgroundImage: "linear-gradient(25deg, #d6c2f0 0%, rgb(255, 255, 255) 70%)", paddingTop: "100px" }}>
                <h1>What Sets  <strong>Shanvatech Apart?</strong></h1>
                {/* <p>Global digital engineering partner building business-facing products for digital natives and enterprises.
        </p> */}
                <div className="row">
                    <div className="col">
                        <div className="card about-Shanva">
                            <div className="card-body">
                                <h5 className="card-title">Comprehensive Hiring Expertise:</h5>
                                <p className="card-text">Covering all aspects of recruitment, from junior roles to executive leadership.</p>
                            </div>
                        </div>
                    </div>
                    <div className="col">
                        <div className="card about-Shanva">
                            <div className="card-body">
                                <h5 className="card-title">Deep Market Insights</h5>
                                <p className="card-text">A keen understanding of industry trends and evolving workforce demands.</p>
                            </div>
                        </div>
                    </div>
                    <div className="col">
                        <div className="card about-Shanva">
                            <div className="card-body">
                                <h5 className="card-title">Expansive Talent Network</h5>
                                <p className="card-text">Leveraging strong industry connections to identify and engage top candidates.</p>

                            </div>
                        </div>
                    </div>
                    <div className="col">
                        <div className="card about-Shanva">

                            <div className="card-body">
                                <h5 className="card-title">Data-Driven Approach</h5>
                                <p className="card-text">A strategic, analytical process that ensures the best-fit talent for every role. </p>

                            </div>
                        </div>
                    </div>
                    <div className="col">
                        <div className="card about-Shanva">

                            <div className="card-body">
                                <h5 className="card-title">Rigorous Screening & Vetting</h5>
                                <p className="card-text">Ensuring each candidate is thoroughly assessed to meet business needs</p>

                            </div>
                        </div>
                    </div>

                </div>
            </div>

            {/* <div className="container-fluid">

                <div className="row client-Stories">

                    <div className="col-md-3">
                        <div className="">
                            <div className="card-body">
                                <h3 className="card-title">Innovation Ideation Resources </h3>
                                <p className="card-text">Looking to expand knowledge, delve deeper into subjects, or embark on a new learning journey? Immerse in our meticulously curated resources, crafted by top industry professionals, and unveil new business alternatives.</p>
                                <a href="#" className="btn btn-primary More-success-Stories">READ MORE</a>
                            </div>
                        </div>
                    </div>
                    {slider1.slice(currentIndex, currentIndex + visibleSlides).map((slide) => (
                        <div className="col-md-3 client-stories-card">
                            <div className="card">
                                <img className="card-img-top" src={slide.src} alt="Card image cap" />
                                <div className="card-body">
                                    <h5 className="card-title">India</h5>
                                    <p className="card-text">4,700+ engineers, designers, SMEs, and technical experts on pace to double
                                        (2x) India operations in the next 3 years</p>
                                    <a href="#" >LEARN MORE</a>
                                </div>
                            </div>
                        </div>
                    ))}


                    {/* <div className="col-md-3 client-stories-card">
        <div className="card ">
            <img className="card-img-top" src="assets/Sagent_background.png" alt="Card image cap" />
            <div className="card-body">
                <h5 className="card-title">India</h5>
                <p className="card-text">4,700+ engineers, designers, SMEs, and technical experts on pace to double
                    (2x) India operations in the next 3 years</p>
                <a href="#" >LEARN MORE</a>
            </div>
        </div>
    </div> */}
                    {/* <div className="col-md-3 client-stories-card">
        <div className="card">
            <img className="card-img-top" src="assets/Switchfly_Background.png" alt="Card image cap" />
            <div className="card-body">
                <h5 className="card-title">India</h5>
                <p className="card-text">4,700+ engineers, designers, SMEs, and technical experts on pace to double
                    (2x) India operations in the next 3 years</p>
                <a href="#" >LEARN MORE</a>
            </div>
        </div>
    </div> 


                </div>

                <div className="d-flex justify-content-end mt-3 pr-4">
                    <button className="btn btn-primary mr-2" onClick={prevSlide1}>
                        Previous
                    </button>
                    <button className="btn btn-primary" onClick={nextSlide1}>
                        Next
                    </button>
                </div>
            </div> */}

            {/* <div className='container-fluid' style={{paddingTop:"50px"}}>
                <div className='row'>
                    <div className='col-md-3'>
                        <img style={{ height: "12%" }} src="assets/Advent.jfif" />
                        <img style={{ height: "16%" }} src="assets/WarburgPincus.png" />
                    </div>
                    <div className='col-md-9'>
                        <h2>Investors</h2>
                        <p>At Shanvatech, we don’t just fill positions—we build careers and empower businesses with talent that drives success.
                        </p>
                        {/* <p>
                            Warburg Pincus LLC is a leading global private equity firm focused on growth investing. The firm has more than $54 billion in private equity assets under management.

                        </p>
                        <p>
                            The firm’s active portfolio of more than 185 companies is highly diversified by stage, sector and geography
                        </p> 
                    </div>
                </div>

            </div> */}

            <div className='container-fluid' style={{paddingTop:"50px"}}>
                <div>
                    <h2 style={{paddingBottom:"30px"}}>Corporate Social Responsibility</h2>
                    <p>shanvatech is devoted to making the world a better place for clients, for our communities and for our people</p>
                    <p>
                        At shanvatech, we seek to enhance people’s quality of life and general wellbeing, whether they belong to our internal communities or our external ones. While our CSR activities vary by country, the scope of our actions addresses a range of important issues, including food insecurity, primary and vocational education, gender equality, and environmental sustainability
                    </p>
                    {/* <ul>
                        <li>Technology fluency training programs for youth</li>
                        <li>Technology fluency training programs for youth</li>
                        <li>Technology fluency training programs for youth</li>
                        <li>Technology fluency training programs for youth</li>
                    </ul> */}
                </div>
            </div>

            {/* <div className="container-fluid " style={{ paddingTtop: "50px" }} >

                <div className="row join-us" >


                    <div className="col-md-9" style={{ padding: "20px" }}>
                        <div className="" >

                            <h1>Join us</h1>
                            <p>Explore our Careers portal to get connected with career opportunities in your area!</p>
                            <button type="submit" className="formSubmit">CAREERS</button>

                        </div>
                    </div>
                    <div className="col-md-3" >
                        <div className="" >

                            <img src="assets/Technology_Consulting_Services.png" style={{ width: "300px", height: "200px" }} />

                        </div>
                    </div>


                </div>
            </div> */}

            <ContactForm />
        </>
    )
}

export default About;